// brugo-web Fix My Home short-form labels (old values stay readable).
export const JOB_SIZES = { small: "Small", medium: "Medium", large: "Large", not_sure: "Not sure" };
export const START_LABELS = {
  "Urgent – in 1–2 days": "Urgent – in 1–2 days", "This week": "This week", "This month": "This month",
  asap: "Urgent – in 1–2 days", "7_days": "This week", "2_4_wks": "This month",
  Immediately: "Immediately (old)", "Within a week": "Within a week (old)", "Within a month": "Within a month (old)", "Just exploring": "Just exploring (old)",
};
export const jobSizeOf = (r) => r?.job_size || r?.customer_form_responses?.job_size || null;
export const jobSizeLabel = (r) => { const j = jobSizeOf(r); return j ? (JOB_SIZES[j] || j) : "—"; };
export const startWhenLabel = (r) => {
  const v = r?.start_when || r?.customer_form_responses?.start_when || r?.professional_summary?.start_when;
  return v ? (START_LABELS[v] || String(v).replace(/_/g, " ")) : "—";
};
export const visitLabel = (r) => {
  const v = r?.customer_form_responses?.visit;
  if (r?.visit_flexible === true || v?.flexible) return "Any time is fine";
  const date = r?.preferred_visit_date || v?.date;
  const slots = (r?.preferred_visit_slots?.length ? r.preferred_visit_slots : v?.slots) || [];
  return date || slots.length ? `${date || ""} ${slots.join(", ")}`.trim() : "—";
};
